(function($, once, Drupal) {

  function deepMerge(obj1, obj2) {
    const result = { ...obj1 };

    for (let key in obj2) {
      if (
        obj2.hasOwnProperty(key) &&
        key !== "__proto__" &&
        key !== "constructor" &&
        key !== "prototype"
      ) {
        if (obj2[key] instanceof Object && obj1[key] instanceof Object) {
          result[key] = deepMerge(obj1[key], obj2[key]);
        } else {
          result[key] = obj2[key];
        }
      }
    }

    return result;
  }

  Drupal.behaviors.carousel = {
    attach(context) {
      once('slides--processed', '[data-component-id="nuplayer:carousel_swiper"]', context).forEach((carousel) => {
        const swiper = $(carousel).find('.swiper');
        const swiper_settings = $(carousel).data('swiper-settings') || {};

        const nextArrow = $(carousel).find('.next-arrow');
        const prevArrow = $(carousel).find('.prev-arrow');
        const pagination = $(carousel).find('.swiper-pagination');

        const swiper_defaults = {
          a11y: true,
          direction: 'horizontal',
          loopPreventsSlides: true,
          spaceBetween: "1.5%",
          loop: true,
          slidesPerView: 4,
          pagination: {
            el: pagination.length > 0 ? pagination[0] : null,
            clickable: true,
          },
          navigation: {
            nextEl: nextArrow.length > 0 ? nextArrow[0] : null,
            prevEl: prevArrow.length > 0 ? prevArrow[0] : null,
          },
        };
        const swiperOptions = deepMerge(swiper_defaults, swiper_settings);
        const swiperCarousel = new Swiper(swiper[0], swiperOptions);
      }
      );
    }
  };
})(jQuery, once, Drupal);
